<template>
  <v-col sm="12" class="overrideCol">
    <div class="mapWrapper" ref="leafletWrapper">
      <l-map
        ref="map"
        :zoom="zoom"
        class="ml-2"
        :max-zoom="maxZoom"
        :center="center"
        :options="mapOptions"
        :style="style"
      >
        <l-tile-layer
          v-for="tile in tileProviders"
          :key="tile.name"
          :visible="tile.visible"
          :url="tile.url"
          :name="tile.name"
          :attribution="tile.attribution"
          layer-type="base"
        />

        <template v-for="(marker, index) in markers">
          <l-marker :key="index" :lat-lng="marker.latLng" :icon="marker.icon">
            <l-popup>
              <div v-html="marker.content"></div>
            </l-popup>
          </l-marker>
        </template>
      </l-map>
      <IncidentReportResult />
    </div>
  </v-col>
</template>

<script>
import options from '../../../resource/maps/leafletOptions'
import BaseLeafletMapComponent from '../BaseLeafletMapComponent'
import { latLng } from 'leaflet'
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControl,
  LControlLayers,
  LPolyline
} from 'vue2-leaflet'
import LDraw from 'leaflet-draw'
import { mapState } from 'vuex'
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
  name: 'LeafletIncidentMapComponent',
  extends: BaseLeafletMapComponent,
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LDraw,
    LControlLayers,
    LControl,
    LPolyline,
    LPolygon: () => import('vue2-leaflet'),
    LCircle: () => import('vue2-leaflet'),
    IncidentReportResult: () => import('../../reports/IncidentReportResult')
  },
  data() {
    return {
      zoom: null,
      maxZoom: null,
      center: null,
      tileProviders: [],
      mapOptions: {
        zoomSnap: null
      },
      poiData: {},
      markers: [],
      bounds: [],
      style: 'height: 100vh'
    }
  },
  computed: {
    ...mapState('incidents', ['selectedIncident', 'incidents'])
  },
  created() {
    let { zoom, maxZoom, zoomSnap, center, tileProviders } = options
    this.zoom = zoom
    this.maxZoom = maxZoom
    this.center = latLng(center.lat, center.lng)
    this.tileProviders = tileProviders
    this.mapOptions.zoomSnap = zoomSnap
  },
  methods: {
    drawIncident(incident) {
      this.markers = []
      this.bounds = []
      var color = 'red'

      if (incident.severity == 2) {
        color = 'red'
      } else if (incident.severity == 1) {
        color = 'orange'
      } else {
        color = 'yellow'
      }

      incident.incidents.forEach(x => {
        this.markers.push({
          id: `Incident ${x.latitude + Math.random()}`,
          latLng: latLng(x.latitude, x.longitude),
          content: `
              <p>${this.getTranslation('Driver')}: ${
            incident.driver ? incident.driver : '/'
          }</p>
              <p>${this.getTranslation('Vehicle')}: ${incident.vehicleLabel}</p>
              <p>${this.getTranslation('Incident type')}: ${translate(
            x.incidentName,
            'incidentType'
          )}</p>
              <p>${this.getTranslation('Incident value')}: ${
            x.incidentValue ? x.incidentValue : '/'
          }</p>
              <p>Poi: ${x.pois ? x.pois : '/'}</p>
            `,
          visible: true,
          icon: this.getCustomMarkerIcon('incident.png', color, 30, 30)
        })
      })
      this.zoomToRoute(
        incident.incidents.map(x => {
          return {
            latitude: x.latitude,
            longitude: x.longitude
          }
        })
      )

      this.fixMissingMarkerIcons()
    },
    getTranslation(toTranslate) {
      return translate(toTranslate, 'incidentType')
    }
  },
  watch: {
    selectedIncident: {
      handler() {
        this.drawIncident(this.selectedIncident)
      }
    },
    incidents: {
      handler() {
        this.$refs.map.mapObject._sizeChanged = true
        if (this.incidents.length) {
          this.style = 'height: 60vh'
        } else {
          this.style = 'height: 100vh'
        }
      }
    }
  }
}
</script>

<style src="leaflet/dist/leaflet.css">
</style>
<style src="leaflet-draw/dist/leaflet.draw.css">
</style>
<style src="../../../assets/icons.css">
</style>
<style>
.vue2leaflet-map {
  z-index: 1 !important;
}
</style>
